import { ReactNode } from 'react'
import ScheduleIcon from '@mui/icons-material/Schedule'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat'
import { EventoNotificacao } from '@/types/notificacao'

export interface AlertaMeta {
  severity: 'info' | 'warning' | 'error' | 'success'
  icon: ReactNode
  action: string
}

/**
 * Mapeamento de cada evento de notificação para severidade + ícone + rota de destino.
 * Compartilhado pelo dashboard do operador e pelo legado (extraído em 11/09).
 */
export const EVENTO_META: Record<EventoNotificacao, AlertaMeta> = {
  DOCUMENTO_ANALISADO:      { severity: 'success', icon: <ErrorOutlineIcon />, action: '/documentos' },
  DOCUMENTO_PROCESSADO:     { severity: 'info',    icon: <ErrorOutlineIcon />, action: '/documentos' },
  CLIENTE_CRIADO:           { severity: 'success', icon: <ScheduleIcon />,     action: '/clientes' },
  CLIENTE_ATUALIZADO:       { severity: 'info',    icon: <ScheduleIcon />,     action: '/clientes' },
  OPORTUNIDADE_CRIADA:      { severity: 'info',    icon: <TrendingFlatIcon />, action: '/oportunidades' },
  ESTAGIO_ATUALIZADO:       { severity: 'info',    icon: <TrendingFlatIcon />, action: '/oportunidades' },
  OPORTUNIDADE_CONTRATADA:  { severity: 'success', icon: <TrendingFlatIcon />, action: '/oportunidades' },
  // Simulador fora do ar (features.ts) — a notificação legada leva ao dashboard.
  SIMULACAO_CRIADA:         { severity: 'info',    icon: <TrendingFlatIcon />, action: '/dashboard' },
  LEMBRETE_ACAO:            { severity: 'warning', icon: <ScheduleIcon />,     action: '/dashboard' },
  PENDENCIA_CRIADA:         { severity: 'warning', icon: <ErrorOutlineIcon />, action: '/pendencias' },
  RESERVA_VENCENDO:         { severity: 'warning', icon: <ScheduleIcon />,     action: '/reservas' },
  RENOVACAO_ANALISADA:      { severity: 'info',    icon: <ScheduleIcon />,     action: '/renovacoes' },
  RESERVA_TRANSFERIDA:      { severity: 'info',    icon: <TrendingFlatIcon />, action: '/reservas' },
  // Fila do back-office: leva direto para as reservas, que é onde a análise começa.
  RESERVA_ENVIADA_ANALISE:  { severity: 'info',    icon: <TrendingFlatIcon />, action: '/reservas' },
  LEMBRETE_AGENDAMENTO:     { severity: 'warning', icon: <ScheduleIcon />,     action: '/agenda' },
}

export function metaPara(evento: EventoNotificacao): AlertaMeta {
  return EVENTO_META[evento] ?? { severity: 'info', icon: <ErrorOutlineIcon />, action: '/dashboard' }
}
